/* u1 coffee — scroll animations, mobile menu, reviews carousel, product dialog.
   Plain script (no build step). Every feature checks for its markup first, so
   the file is safe on every page. */
(() => {
  const clamp = (v) => Math.max(0, Math.min(1, v));
  const ease = (t) => -(Math.cos(Math.PI * t) - 1) / 2;
  const isMobile = () => window.innerWidth < 760;

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    const btn = document.querySelector('[data-u1-menu-btn]');
    const menu = document.getElementById('u1-mmenu');
    if (!btn || !menu) return;
    const set = (open) => {
      btn.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    btn.addEventListener('click', () => set(btn.getAttribute('aria-expanded') !== 'true'));
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { set(false); btn.focus(); } });
    window.addEventListener('resize', () => { if (!isMobile() && !menu.hidden) set(false); });
  }

  /* ---------- Scroll scenes ---------- */
  const cup = {};
  function initCup() {
    cup.section = document.querySelector('[data-u1-cup]');
    if (!cup.section) return false;
    cup.stage = cup.section.querySelector('[data-u1-cup-stage]');
    cup.lid = cup.section.querySelector('[data-part="lid"]');
    cup.sleeve = cup.section.querySelector('[data-part="sleeve"]');
    cup.backBehind = cup.section.querySelector('[data-part="back-behind"]');
    cup.backFront = cup.section.querySelector('[data-part="back-front"]');
    cup.labels = {
      cup: cup.section.querySelector('[data-label="cup"]'),
      lid: cup.section.querySelector('[data-label="lid"]'),
      sleeve: cup.section.querySelector('[data-label="sleeve"]'),
    };
    cup.target = 0;
    cup.current = 0;
    return true;
  }
  function measureCup(vh) {
    const r = cup.stage.getBoundingClientRect();
    const startTop = vh + 0.048 * r.height;      // lid's top edge enters the screen
    const endTop = vh - 40 - 0.96 * r.height;     // whole cup is in view
    cup.target = clamp((startTop - r.top) / Math.max(1, startTop - endTop));
  }
  function paintCup(p) {
    const e1 = ease(clamp(p / 0.75));
    const e2 = ease(clamp((p - 0.2) / 0.8));
    const m = isMobile();
    const k = clamp((e2 - 0.03) / 0.15);
    if (cup.lid) cup.lid.style.transform = `translate(${-2 * e1}%, ${-55 * e1}%) rotate(${-7 * e1}deg)`;
    const st = `translate(${(m ? 46 : 82) * e2}%, ${(m ? 48 : 30) * e2}%) rotate(${5 * e2}deg)`;
    if (cup.sleeve) cup.sleeve.style.transform = st;
    if (cup.backBehind) { cup.backBehind.style.transform = st; cup.backBehind.style.opacity = String(1 - k); }
    if (cup.backFront) cup.backFront.style.opacity = String(k);
    if (cup.labels.cup) cup.labels.cup.style.opacity = String(clamp((p - 0.02) / 0.1));
    if (cup.labels.lid) cup.labels.lid.style.opacity = String(clamp((e1 - 0.6) / 0.4));
    if (cup.labels.sleeve) cup.labels.sleeve.style.opacity = String(clamp((e2 - 0.6) / 0.4));
  }

  const hero = document.querySelector('[data-u1-hero]');

  const mac = {};
  function initMac() {
    mac.section = document.querySelector('[data-u1-mac]');
    if (!mac.section) return false;
    mac.rows = [...mac.section.querySelectorAll('[data-u1-mac-row]')];
    mac.imgs = mac.rows.map((row) => [...row.querySelectorAll('img')]);
    return true;
  }
  const tilt = [-8, 6, -4, 10, -6, 4];
  function paintMac(vh) {
    const r = mac.section.getBoundingClientRect();
    if (r.bottom < -200 || r.top > vh + 200) return;
    const mp = clamp((vh - r.top) / (vh + r.height));
    mac.rows.forEach((row, ri) => {
      const dx = ri === 0 ? Math.round((mp - 0.5) * -900) : Math.round((mp - 0.5) * 900) - 240;
      row.style.transform = `translateX(${dx}px)`;
      mac.imgs[ri].forEach((img, i) => {
        img.style.transform = `rotate(${Math.round(tilt[i % 6] * (0.4 + mp))}deg)`;
      });
    });
  }

  const shop = {};
  function initShop() {
    shop.section = document.querySelector('[data-u1-shop]');
    if (!shop.section) return false;
    shop.grid = shop.section.querySelector('[data-u1-shop-grid]');
    shop.floats = [...shop.section.querySelectorAll('[data-u1-float]')];
    shop.inView = false;
    return true;
  }
  function checkShop(vh) {
    const r = shop.grid.getBoundingClientRect();
    const inView = r.top < vh * 0.88 && r.bottom > 0;
    if (inView === shop.inView) return;
    shop.inView = inView;
    shop.section.classList.toggle('is-in', inView);
  }
  function paintFloat(now) {
    if (!shop.inView) return;
    const t = now / 1000;
    shop.floats.forEach((el, i) => {
      const s = Math.sin(t * (Math.PI * 2 / 6) + i * Math.PI);
      el.style.transform = `translateY(${(-6 - 6 * s).toFixed(2)}px) rotate(${(-0.6 - 0.6 * s).toFixed(2)}deg)`;
    });
  }

  function initScenes() {
    const hasCup = initCup();
    const hasMac = initMac();
    const hasShop = initShop();
    if (!hasCup && !hasMac && !hasShop && !hero) return;

    const measure = () => {
      const vh = window.innerHeight || 800;
      if (hasCup) {
        measureCup(vh);
        if (hero) {
          const top = cup.section.getBoundingClientRect().top;
          hero.style.opacity = String(0.35 + clamp(1 - (vh - top) / (vh * 1.4)) * 0.65);
        }
      }
      if (hasMac) paintMac(vh);
      if (hasShop) checkShop(vh);
    };

    // Measure every frame as well as on scroll: some themes scroll an inner
    // element instead of the window, which never fires window 'scroll'.
    const loop = (now) => {
      measure();
      if (hasCup) {
        const d = cup.target - cup.current;
        cup.current = Math.abs(d) < 0.0008 ? cup.target : cup.current + d * 0.035;
        paintCup(cup.current);
      }
      if (hasShop) paintFloat(now);
      requestAnimationFrame(loop);
    };

    document.addEventListener('scroll', measure, { passive: true, capture: true });
    window.addEventListener('resize', measure);
    measure();
    if (hasCup) { cup.current = cup.target; paintCup(cup.current); }
    requestAnimationFrame(loop);
  }

  /* ---------- Reviews carousel ---------- */
  function initReviews() {
    document.querySelectorAll('[data-u1-reviews]').forEach((root) => {
      const slides = [...root.querySelectorAll('[data-u1-slide]')];
      const dots = [...root.querySelectorAll('[data-u1-dot]')];
      if (slides.length < 2) return;
      let index = 0;
      let timer;
      const show = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => { s.hidden = n !== index; });
        dots.forEach((d, n) => d.setAttribute('aria-current', String(n === index)));
      };
      const restart = () => {
        clearInterval(timer);
        timer = setInterval(() => show(index + 1), 8000);
      };
      dots.forEach((d, n) => d.addEventListener('click', () => { show(n); restart(); }));
      root.querySelector('[data-u1-prev]')?.addEventListener('click', () => { show(index - 1); restart(); });
      root.querySelector('[data-u1-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
      show(0);
      restart();
    });
  }

  /* ---------- Cart count ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-u1-cart-count]').forEach((el) => {
        el.textContent = String(cart.item_count);
        el.hidden = cart.item_count === 0;
      });
    } catch (e) { /* count stays as rendered */ }
  }

  /* ---------- Product dialog ---------- */
  function initProductDialog() {
    const dialog = document.querySelector('[data-u1-modal]');
    if (!dialog) return;
    const $ = (sel) => dialog.querySelector(sel);
    const img = $('[data-m-img]');
    const title = $('[data-m-title]');
    const price = $('[data-m-price]');
    const desc = $('[data-m-desc]');
    const variantsBox = $('[data-m-variants]');
    const qtyOut = $('[data-m-qty]');
    const addBtn = $('[data-m-add]');
    const status = $('[data-m-status]');
    const link = $('[data-m-link]');
    let data = null;
    let variantId = null;
    let qty = 1;
    let opener = null;

    const selectVariant = (v) => {
      variantId = v ? v.id : null;
      price.textContent = v ? v.price : '';
      addBtn.disabled = !v || !v.available;
      addBtn.textContent = !v ? addBtn.dataset.labelSoon : (v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold);
    };

    const open = (json, trigger) => {
      data = json;
      opener = trigger;
      qty = 1;
      qtyOut.value = '1';
      status.textContent = '';
      img.src = data.image || '';
      img.alt = data.title || '';
      title.textContent = data.title || '';
      desc.innerHTML = data.description || '';
      link.hidden = !data.url;
      if (data.url) link.href = data.url;
      variantsBox.innerHTML = '';
      const vs = data.variants || [];
      if (vs.length > 1) {
        const fs = document.createElement('fieldset');
        fs.className = 'u1-variants';
        const lg = document.createElement('legend');
        lg.textContent = data.optionName || 'Option';
        fs.appendChild(lg);
        vs.forEach((v, i) => {
          const label = document.createElement('label');
          label.className = 'u1-variant';
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = 'u1-variant';
          input.value = String(v.id);
          input.disabled = !v.available;
          const span = document.createElement('span');
          span.textContent = v.title;
          input.addEventListener('change', () => selectVariant(v));
          label.append(input, span);
          fs.appendChild(label);
          if (i === vs.findIndex((x) => x.available)) input.checked = true;
        });
        variantsBox.appendChild(fs);
      }
      selectVariant(vs.find((v) => v.available) || vs[0] || null);
      dialog.showModal();
    };

    document.querySelectorAll('[data-u1-open]').forEach((card) => {
      card.addEventListener('click', () => {
        const node = document.getElementById(card.dataset.u1Open);
        if (!node) return;
        try { open(JSON.parse(node.textContent), card); } catch (e) { /* malformed data */ }
      });
    });

    dialog.querySelectorAll('[data-m-close]').forEach((b) => b.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { opener?.focus(); });
    $('[data-m-minus]').addEventListener('click', () => { qty = Math.max(1, qty - 1); qtyOut.value = String(qty); });
    $('[data-m-plus]').addEventListener('click', () => { qty += 1; qtyOut.value = String(qty); });

    addBtn.addEventListener('click', async () => {
      if (!variantId) return;
      addBtn.disabled = true;
      status.textContent = addBtn.dataset.labelAdding;
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
        });
        const body = await res.json();
        if (!res.ok) throw new Error(body.description || body.message || 'Error');
        status.innerHTML = '';
        status.append(document.createTextNode(`${addBtn.dataset.labelAdded} `));
        const a = document.createElement('a');
        a.href = `${window.Shopify?.routes?.root || '/'}cart`;
        a.textContent = addBtn.dataset.labelView;
        status.appendChild(a);
        refreshCartCount();
      } catch (err) {
        status.textContent = err.message;
      } finally {
        addBtn.disabled = false;
      }
    });
  }

  const start = () => {
    initMenu();
    initScenes();
    initReviews();
    initProductDialog();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
